// extracted by mini-css-extract-plugin
module.exports = {"container":"ApiRemoveButton__container___32XZa","close":"ApiRemoveButton__close___1rrVe","text":"ApiRemoveButton__text___1FA5S"};